<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-confirm-edit-status"
      :title="$t('common.edit-status')"
      ok-only
      :ok-title="$t('common.edit')"
      @ok="changeInvoiceStatus()"
    >
      <b-card-text>
        <h5>{{ $t("common.invoice-sure") }}</h5>
        {{ $t("common.invoice-no-comeback") }}
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="createMode ? $t('QuickInvoice.Add') : $t('QuickInvoice.Edit')"
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <AutoComplete
              :label="$t('QuickInvoice.tyoe')"
              :placeholder="$t('QuickInvoice.tyoe')"
              v-model="EditForm.quickInvoiceData"
              :serializer="(val) => val"
              noSort
              endpoint="quickInvoiceTypes"
              text-title="name"
              @input="onSelectquickInvoice"
            />
            <p class="text-danger mt-1">
              {{ errorForm.quick_invoice_type_id }}
            </p>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('QuickInvoiceType.amount')"
              label-for="name"
            >
              <b-form-input
                v-model="EditForm.amount"
                :placeholder="$t('QuickInvoiceType.amount')"
                :disabled="true"
              />
              <p class="text-danger mt-1">{{ errorForm.amount }}</p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      :id="`modal-confirm-print`"
      :title="$t('surgery.print-invoice')"
      ok-only
      :ok-title="$t('common.print')"
      @ok="printQuickInvoice"
    >
      <b-card-text>
        <h5>{{ $t("surgery.print-invoice") }}</h5>
        {{ $t("surgery.print-sure") }}
      </b-card-text>
    </b-modal>
    <b-card :title="$t('QuickInvoice.title')">
      <div>
        <!-- Data Table  -->
        <b-row>
          <b-col cols="3">
            <AutoComplete
              v-model="quick_invoice_type_id"
              :label="$t('QuickInvoice.tyoe')"
              :placeholder="$t('QuickInvoice.tyoe')"
              :serializer="(val) => val.id"
              noSort
              endpoint="quickInvoiceTypes"
              text-title="name"
            />
          </b-col>
          <b-col cols="3">
            <b-form-group
              :label="$t('common.from') + ' ' + $t('common.Date')"
              label-for="Date"
            >
              <datepicker
                v-model="created_at_ge"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              :label="$t('common.to') + ' ' + $t('common.Date')"
              label-for="Date"
            >
              <datepicker
                v-model="created_at_le"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>

          <b-col cols="3" class="d-flex align-items-center">
            <b-button variant="primary" @click="getServicesList()">
              {{ $t("common.search") }}
            </b-button>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("QuickInvoice.title") }}</h2>
          <b-button
            variant="primary"
            @click="show(EditForm, 'create')"
            v-if="$store.state.app.permissions.includes('store-quickInvoice')"
          >
            {{ $t("common.add") }}
          </b-button>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
          style="min-height: 400px"
        >
          <template #cell(created_at)="data">
            <p
              class="mx-2 d-inline"
              style="unicode-bidi: isolate"
              :style="{
                direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
              }"
            >
              {{ data.item.created_at }}
            </p>
          </template>
          <!-- Column: Actions -->
          <template #cell(status)="data">
            <b-dropdown
              size="sm"
              :text="data.item.status"
              :variant="badgeVariant(data.item.status)"
              class="text-light"
           
            >
              <b-dropdown-item
                v-if="showOption('pending', data.item)"
                style="z-index: 999"
                @click="showChangeStatusModal('pending', data.item.id)"
              >
                Pending
              </b-dropdown-item>
              <b-dropdown-item
                v-if="showOption('approved', data.item)"
                style="z-index: 999"
                @click="showChangeStatusModal('approved', data.item.id)"
              >
                Approved
              </b-dropdown-item>
              <b-dropdown-item
                v-if="showOption('rejected', data.item)"
                style="z-index: 999"
                @click="showChangeStatusModal('rejected', data.item.id)"
              >
                Rejected
              </b-dropdown-item>
            </b-dropdown>
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap d-flex">
              <b-button
                v-if="data.item.status == 'approved'"
                @click="showPrintQuickInvoice(data.item)"
                variant="outline-primary"
                size="sm"
                pill
                class="mx-1"
              >
                {{ $t("reception.Print Invoice") }}
              </b-button>
              <b-button
                v-if="data.item.status == 'approved'"
                ref="quickInvoiceRef"
                v-print="OutClinicInvoice"
                variant="outline-primary"
                pill
                size="sm"
                class="mx-1 hidden"
                >{{ $t("common.print") }}</b-button
              >
              <ActionsButtons
                deletePerm="delete-service"
                editPerm="update-service"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Services</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getServicesList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
      <QuickPrintInvoice :data="dataQuickInvoice"  />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BCardText,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import QuickPrintInvoice from "./QuickPrintInvoice.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";
import formValid from "@/utils/formValid";
export default {
  mixins: [permissionChecker],
  components: {
    DeleteModal,
    BCard,
    ActionsButtons,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BCardText,
    VuePhoneNumberInput,
    AutoComplete,
    QuickPrintInvoice,
    Datepicker,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        title: "",
        price: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        title: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        {
          key: "type.name",
          sortable: true,
          label: this.$t("QuickInvoiceType.name"),
        },
        {
          key: "amount",
          sortable: true,
          label: this.$t("QuickInvoiceType.default_amount"),
        },
        {
          key: "status",
          sortable: true,
          label: this.$t("QuickInvoiceType.status"),
        },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("QuickInvoiceType.created_at"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      invoiceLatestStatus: "",
      InvoiceId: "",
      quickInvoiceData: {},
      invoice: {},
      quick_invoice_type_id: "",
      OutClinicInvoice: {
        id: "OutClinicInvoice",
      },
      created_at_ge: "",
      created_at_le: "",
      dataQuickInvoice: null,
    };
  },
  mounted() {
    this.getServicesList();
  },
  methods: {
    showPrintQuickInvoice(data) {
      this.dataQuickInvoice = data;
      this.$bvModal.show("modal-confirm-print");
    },
    printQuickInvoice() {
      console.log("dataQuickInvoice", this.dataQuickInvoice);
      this.$refs.quickInvoiceRef.click();
    },
    showChangeStatusModal(status, id) {
      this.invoiceLatestStatus = status;
      this.InvoiceId = id;
      this.$nextTick(() => {
        this.$bvModal.show(`modal-confirm-edit-status`);
      });
    },
    badgeVariant(status) {
      switch (status) {
        case "pending":
          return "warning";
        case "rejected":
          return "danger";
        default:
          return "success";
      }
    },
    onSelectquickInvoice(item) {
      this.EditForm.amount = item.default_amount;
      this.EditForm.quick_invoice_type_id = item.id;
    },
    printInvoice(item) {
      this.invoice = item;
    },

    showOption(option, rowData) {
      const statusSequence = ["pending", "approved"];
      const currentIndex = statusSequence.indexOf(rowData.status);
      const optionIndex = statusSequence.indexOf(option);

      if (rowData.status === "approved" || rowData.status === "rejected") {
        return false;
      }

      return option === "rejected" || optionIndex === currentIndex + 1;
    },
    changeInvoiceStatus() {
      (this.params.form = { status: this.invoiceLatestStatus }),
        (this.params.path = `/quickInvoices/${this.InvoiceId}`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            this.getServicesList();
            this.$bvModal.hide(`modal-confirm-edit-status`);
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          title: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.title = item.title;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    formatDate(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    async getServicesList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/quickInvoices?page=${this.page}&take=${this.take}&include=type&sort=-id`;

      if (this.quick_invoice_type_id) {
        url += `&filter[quick_invoice_type_id]=${this.quick_invoice_type_id}`;
      }
      if (this.created_at_ge) {
        url += `&filter[created_at-ge]=${this.formatDate(this.created_at_ge)}`;
      }
      if (this.created_at_le) {
        url += `&filter[created_at-le]=${this.formatDate(this.created_at_le)}`;
      }
      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/quickInvoices/${this.deleteForm.id}`)
        .then((response) => {
          this.getServicesList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      this.loading = true;
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      const requiredFields = {
        amount: "The amount field is required.",
        quick_invoice_type_id: "The quick invoice type field is required.",
      };
      const { isValid, errorForm } = formValid(
        this.EditForm,
        requiredFields,
        this.errorForm
      );
      if (!isValid) {
        this.errorForm = errorForm;
        this.loading = false;
        for (let item in errorForm) {
          if (errorForm[item]) {
            // this.$toast({
            //   component: ToastificationContent,
            //   position: "top-right",
            //   props: {
            //     title: "validation error",
            //     variant: "danger",
            //     text: errorForm[item],
            //     icon: "danger",
            //   },
            // });
          }
        }
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/quickInvoices`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getServicesList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/quickInvoices/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getServicesList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
